<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="ratesService.loading$"
	[confirmButtonText]="'gl.yes'"
	[closeButtonText]="'gl.no'"
	size="md"
	class="removingDialog"
>
	<h3 slot="header">
		<app-circle-warning></app-circle-warning>
		<div>
			{{ "gl.warning" | translate }}
		</div>
	</h3>
	<div slot="content">
		<p>
			{{ "rates.editDialog" | translate }}
		</p>
	</div>
</alaris-dialog>
